import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Col, Row } from "react-bootstrap";
//import Currency from "./../../../Images/currency.png";
import Currency from "./../../../Images/home-products/currency.png";
import CurrencyFAQ from "./CurrencyFAQ/CurrencyFAQ";
import TrackApi from "../../Activity_Track/TrackApi";
import { useEffect } from "react";
import { useCookies } from "react-cookie";
function CurrencyProduct() {
  const [cookies, setCookie] = useCookies(['LeadId']);

  let navigate = useNavigate();
  const routeChange = () => {
    let path = `/AllEquities`;
    navigate(path);
  };

  const trackData=(id)=>{
    const payloadData={
      "RelatedProspectId":id,
      "ActivityNote": "Your Currency Note",
      "mx_Custom_1": "Currency",
      "mx_Custom_2": "Currency IPO page Note",
      "mx_CustomObject_81":window.location.href
     }
     TrackApi(payloadData);
  }
  useEffect(()=>{
  
if(cookies && cookies.RelatedProspectId){
  trackData(cookies.RelatedProspectId);
}
    
  },[])
  return (
    <>
      {/* <div>IPO Product testing</div> */}
      <section className="welcome-equity">
        <Container>
          <Row>
            <Col lg={4} md={6} sm={12}>
              <div className="welcome-img-block">
                <img className="img-fluid" src={Currency} alt="EquityImg" />
              </div>
            </Col>
            <Col lg={8} md={6} sm={12}>
              <div className="welcome-equity-beta">
                <h3>
                  <span>Currency</span>
                </h3>
                <p>
                  Foreign exchange is the most liquid, decentralised,
                  over-the-counter market, with a daily volume of more than $6.6
                  trillion in 2019. Individuals and institutions from all over
                  the world buy and sell currencies on the currency market. The
                  foreign exchange market is crucial because it allows currency
                  conversion, which enables international trade and investment.
                  Participants include banks, central banks, investment
                  management firms, and investors.
                </p>
                {/* <a onClick={routeChange}>
                  <span>Explore</span>
                </a>
                <button type="button">Sign Up</button> */}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="why-equity-block">
        <Container className="add-border">
          <Row>
            <Col lg={12} md={12} sm={12}>
              <div className="why-equitie-inn">
                <h3>
                  <span>Why Currency</span>
                </h3>
                <p>
                 Most when people think about trading, the first and final thing that comes to mind is stock trading. On the other hand, Currency trading like stock trading also takes place through an exchange. Mostly currencies are traded by importers and exporters whose revenues are determined by the exchange rate. You may profit by buying and selling currencies. It is the most liquid market in the world since it trades in large quantities on a daily basis. The strength of a country's currency trading is determined by demand-supply, geopolitical situation, deficits, import-export, and economic health.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <CurrencyFAQ />
    </>
  );
}
export default CurrencyProduct;
